export var booleanOptions = [{
  id: 'yes',
  name: 'REGISTRATION.YES'
}, {
  id: 'no',
  name: 'REGISTRATION.NO'
}];